module.exports = __webpack_public_path__ + "static/media/resolutions.73045230.svg";